import { createFileRoute } from '@tanstack/react-router';

import { QuoteRequestTemplatePage } from '@/areas/quote-requests/QuoteRequestTemplates/QuoteRequestTemplatesPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/templates/_sidebar/quote-request/')({
    staticData: { access: { permissions: ['view:sourcing'] }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <QuoteRequestTemplatePage />;
}
